import {
  PUT_STATIONS_CATALOG,
  PUT_STATIONS_CATALOG_SUCCESS,
  PUT_STATIONS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const postStationsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case PUT_STATIONS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_STATIONS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_STATIONS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
